module.exports = __webpack_public_path__ + "static/media/btc-logo.59d6b972.png";